package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Expense_list_item(
  public val id: String,
  public val list_id: String,
  public val name: String,
  public val planned: Long,
  public val actual_: Long?,
  public val cat_id: String?,
  public val is_done: Long,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
